//工单管理
const workOrderEn = {
  workOrderLang: {
    工单管理: 'Work order management',
    新建工单: 'New construction work order',
    待分配: 'To be distributed',
    待接单: 'Pending order',
    处理中: 'In process',
    已处理: 'Processed',
    已完成: 'Completed',
    已关闭: 'Closed',

    选择站点: 'Select site',
    工单类型: 'Order type',
    请选择: 'Please select',
    全部: 'All',
    安装工单: 'Installation work order',
    维修工单: 'Maintenance work order',

    时间范围: 'Time frame',
    开始日期: 'Start date',
    结束日期: 'Finish date',
    开始月份: 'Starting month',
    结束月份: 'End month',
    开始年份: 'Starting year',
    结束年份: 'End year',

    请输入工单编号标题内容: 'work order number / title / content...',
    查询: 'Query',
    重置: 'Reset',
    序号: 'Serial Number',
    工单编号: 'Work order number',
    电站名称: 'Name of power station',
    紧急程度: 'Degree of urgency',
    紧急: 'Exigency',
    一般: 'Normal',
    创建时间: 'Creation time',
    工单标题: 'Work order heading',
    创建人: 'Founder',
    操作: 'Operation',
    查看: 'Examine',
    编辑: 'Edit',
    分配: 'Distribution',
    关闭: 'Close',
    暂无数据: 'No data available',
    分配工单: 'Distribution work order',
    处理人: 'Processor',
    请选择处理人: 'Please select the handler',
    取消: 'Cancel',
    确定: 'Confirm',
    关闭工单: 'Close work order',
    关闭原因: 'Shutdown reason',
    填写关闭原因: 'Fill in the closure reason',
    分配工单成功: 'The work order was assigned successfully.',
    关闭工单成功: 'Closing the work order succeeded.',

    编辑工单: 'Edit worksheet',
    选择系统: 'Select system',
    处理方式: 'Processing mode',
    请输入: 'Please enter',
    工单详情: 'Work order details',
    客户名称: 'Customer name',
    客户联系人: 'Customer contact',
    客户联系电话: 'Customer contact number',
    客户地址: 'Customer address',
    请选择工单类型: 'Please select a work order type!',
    请选择站点: 'Please select a site!',
    请输入工单标题: 'Please enter the ticket title!',
    工单标题必须少于50个字符: 'Content cannot exceed 50 characters',
    处理方式必须少于20个字符: 'Content cannot exceed 20 characters',
    客户名称必须少于20个字符: 'Content cannot exceed 20 characters',
    客户联系人必须少于20个字符: 'Content cannot exceed 20 characters',
    客户地址必须少于50个字符: 'Content cannot exceed 50 characters',
    工单详情必须少于200个字符: 'Content cannot exceed 200 characters',
    联系电话必须少于20个字符: 'Content cannot exceed 20 characters',
    编辑成功: 'Edit success',
    新建成功: 'Creation success',
    确认工单: 'Confirmation work order',
    查看工单: 'View work order',
    系统名称: 'System name',
    返回: 'Return',
    工单旅程: 'Ticket journey',
    分配至: 'Be assigned to',
    接单账号: 'Order receiving account number',
    上传图片: 'Upload Image',
    上传文件: 'Upload files',
    处理描述: 'Process description',
    确认完成: 'Confirm',
    接收工单: 'Receipt of work order',
    处理完成: 'Processing complete',
    处理进度更新: 'Processing progress updates',
    工单已确认处理完成: 'The work order has been confirmed to be processed',

    选择站点: 'Select site',
    接单: 'Order taking',
    是否确认接单: 'Confirm receiving order or not?',
    提示: 'Hint',
    接单成功: 'Order accepted successfully',
    分配时间: 'Allocate time',
    处理跟进: 'Follow-up processing',
    处理结束: 'Processing completed',

    接单时间: 'Order receiving time',
    处理结束时间: 'End of processing time',
    填写工单处理内容后点击确认即可结束处理此工单: 'Fill in the processing content of the work order and click "Confirm" to finish processing the work order.',
    填写内容后点击提交即可更新工单处理状态: 'Fill in the content and click Submit to update the work order processing status.',
    点击上传图片: 'Click to upload',
    上传的图片大小不得超过5M支持PNGJPG格式最多可上传5张图片: 'The size of uploaded images should not exceed 5M, supporting PNG and JPG formats, and up to 5 images can be uploaded',
    工单附件: 'Work order attachment',
    点击上传附件: 'Upload attachment',
    上传的附件只支持pdfdocdocxxlsxlsxtxt格式: 'The uploaded attachments only support pdf, doc, docx, xls, xlsx, txt',
    处理描述必须少于100个字符: 'Content cannot exceed 100 characters',
    处理结束成功: 'End of processing successful',
    失败: 'failed ',
    处理跟进成功: 'Processing follow up success',
    图片大小不可超过5M: 'Image size cannot exceed 5M',
    文件大小不可超过10M: 'File size cannot exceed 10M',
    最多5张图片当前总数已超过请重新选择: 'Up to 5 images, the current total number has exceeded. Please reselect!',
    最多5个附件当前总数已超过请重新选择: 'Maximum 5 attachments The current total number exceeds the limit. Please select another attachment.',
    站点系统: 'Site System',
    完成时间: 'Completion time',
    关闭时间: 'Closing time'
  }
}
export default workOrderEn
